import { isPlayingFromBeginningVar } from '../../movie-player/utils/is-playing-from-beginning-var';
import { promoContentIdVar } from '../../movie-player/hooks/use-promo-content-id-var';
import { trailerStartPositionVar } from '../../movie-trailer-player/utils/trailer-start-position-var';

export const cleanPlayingParams = () => {
    isPlayingFromBeginningVar.set(false);
    trailerStartPositionVar.set(0);
    promoContentIdVar.set(null);
};
